import isNull from 'lodash/isNull';
import type { LatLon } from 'app/types';

type ListingWithGeo = {
  geo: LatLon;
};

type DirectionsLinks = {
  cycling: string;
  driving: string;
  transit: string;
  walking: string;
};

const controller = {
  buildDirectionsUrl(from: LatLon, to: LatLon, travelMode: string): string {
    return (
      'https://www.google.com/maps/dir/?api=1&origin=' +
      from.lat +
      ',' +
      from.lon +
      '&destination=' +
      to.lat +
      ',' +
      to.lon +
      '&travelmode=' +
      travelMode
    );
  },

  getGoogleDirectionsLinks(listing: ListingWithGeo, userPoint: LatLon | null): DirectionsLinks | undefined {
    if (isNull(userPoint)) {
      return;
    }

    return {
      cycling: controller.buildDirectionsUrl(listing.geo, userPoint, 'bicycling'),
      driving: controller.buildDirectionsUrl(listing.geo, userPoint, 'driving'),
      transit: controller.buildDirectionsUrl(listing.geo, userPoint, 'transit'),
      walking: controller.buildDirectionsUrl(listing.geo, userPoint, 'walking'),
    };
  },
};

export default controller;
